import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
  ChangeDetectionStrategy
} from '@angular/core';
import { AnimationService } from 'src/app/services/animation/animation.service';
import { CursorService } from 'src/app/services/cursor_animation/cursor.service';

@Component({
  selector: 'app-queen-idia',
  templateUrl: './queen-idia.component.html',
  styleUrls: ['./queen-idia.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class QueenIdiaComponent implements OnInit {
  @ViewChildren('textContent') textContent!: QueryList<ElementRef>;

  constructor(
    private cursorService: CursorService,
    private animate: AnimationService
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const elements = this.textContent.toArray().map((el) => el.nativeElement);
    if (elements) {
      this.animate.fadeInElementsImmediate(elements, 0.05);
      console.log('1st');
    }
  }

  onMouseEnter(): void {
    this.cursorService.hoverElement();
  }

  onMouseLeave(): void {
    this.cursorService.unhoverElement();
  }

  onMouseColorChange(color: string) {
    this.cursorService.changeCursorColor(color);
  }
  onChangeColorBack(color: string) {
    this.cursorService.changeCursorColorBack(color);
  }
}
